import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import pollService from '../services/pollService';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiMinus, FiCheck, FiArrowLeft } = FiIcons;

const CreatePoll = () => {
  const navigate = useNavigate();
  const [question, setQuestion] = useState('');
  const [categories, setCategories] = useState(['', '']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const addCategory = () => {
    if (categories.length < 5) {
      setCategories([...categories, '']);
    }
  };

  const removeCategory = (index) => {
    if (categories.length > 2) {
      const newCategories = categories.filter((_, i) => i !== index);
      setCategories(newCategories);
    }
  };

  const updateCategory = (index, value) => {
    const newCategories = [...categories];
    newCategories[index] = value;
    setCategories(newCategories);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!question.trim() || categories.some(cat => !cat.trim())) {
      setError('Bitte füllen Sie alle Felder aus.');
      return;
    }

    setLoading(true);
    try {
      const { pollId, hostToken } = await pollService.createPoll(
        question,
        categories.filter(cat => cat.trim())
      );
      
      navigate(`/poll/${pollId}/host?token=${hostToken}`);
    } catch (error) {
      console.error('Error creating poll:', error);
      setError(error.message || 'Fehler beim Erstellen der Umfrage. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white py-8">
      <div className="container mx-auto px-4 max-w-2xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-primary hover:opacity-80 mb-8 transition-opacity"
          >
            <SafeIcon icon={FiArrowLeft} className="mr-2" />
            Zurück zur Startseite
          </button>

          <div className="bg-white rounded-lg shadow-lg p-8 border border-gray-100">
            <h1 className="text-3xl font-bold text-primary mb-8 text-center">
              Neue Umfrage erstellen
            </h1>

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                <p className="text-red-700">{error}</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-primary mb-2">
                  Umfrage-Frage
                </label>
                <input
                  type="text"
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  placeholder="z.B. Welches Filmgenre ist am besten?"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors text-primary"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-primary mb-4">
                  Kategorien (2-5 Stück)
                </label>
                <div className="space-y-3">
                  {categories.map((category, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <input
                        type="text"
                        value={category}
                        onChange={(e) => updateCategory(index, e.target.value)}
                        placeholder={`Kategorie ${index + 1}`}
                        className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors text-primary"
                        required
                      />
                      {categories.length > 2 && (
                        <button
                          type="button"
                          onClick={() => removeCategory(index)}
                          className="p-2 text-red-500 hover:text-red-700 transition-colors"
                        >
                          <SafeIcon icon={FiMinus} className="text-xl" />
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                {categories.length < 5 && (
                  <button
                    type="button"
                    onClick={addCategory}
                    className="mt-3 flex items-center text-primary hover:opacity-80 transition-opacity"
                  >
                    <SafeIcon icon={FiPlus} className="mr-2" />
                    Kategorie hinzufügen
                  </button>
                )}
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full btn-primary font-semibold py-4 px-6 rounded-lg transition-all duration-200 flex items-center justify-center"
              >
                {loading ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                ) : (
                  <>
                    <SafeIcon icon={FiCheck} className="mr-2" />
                    Umfrage erstellen
                  </>
                )}
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CreatePoll;